import React, { Component } from 'react';
import { Dispatcher, Events, Actions } from '../../flux';
import { Logo, DelayLink } from '../';
import { images } from '../../settings';
import { globalDelay } from '../../settings';

import { TimelineMax, TweenMax } from 'gsap';
import { Header } from '../';

import './Menu.scss';

class Menu extends Component {
  state = {
    menuVisible: false,
  };
  imagemMenu = images.menuAberto.pessoa;

  componentDidMount = () => {
    this.timelineTransition = new TimelineMax();
  };

  componentWillMount = () => {
    Dispatcher.on(Events.SHOW_MENU, this.dShowMenu.bind(this));
    Dispatcher.on(Events.HIDE_MENU, this.dHideMenu.bind(this));
  };

  componentWillUnmount = () => {
    Dispatcher.removeListener(Events.SHOW_MENU, this.dShowMenu);
    Dispatcher.removeListener(Events.HIDE_MENU, this.dHideMenu);
  };

  dShowMenu() {
    this.showMenu();
  }

  dHideMenu() {
    this.hideMenu();
  }

  showMenu() {
    this.timelineTransition.add(
      TweenMax.fromTo(this.refs.siteMenu, 1, { autoAlpha: 0, y: 180 }, { autoAlpha: 1, y: 0 })
    );
    this.setState({ menuVisible: true });
  }

  hideMenu() {
    this.timelineTransition.add(TweenMax.fromTo(this.refs.siteMenu, 0.01, { autoAlpha: 1 }, { autoAlpha: 0 }));
    this.setState({ menuVisible: false });
  }

  menuClicked() {
    setTimeout(function() {
      Actions.toggleMenu();
    }, 800);
  }

  render = () => {
    const { menuVisible } = this.state;
    const { closeMenu } = this.props;
    const classes = menuVisible ? ['menu', 'menu--active'] : ['menu'];
    return (
      <div className={classes.join(' ')} id="siteMenu" ref="siteMenu">
        <Header menuClicked={closeMenu} />
        <div>
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="topo-menu">
                  <p>
                    Relatório Anual <span>Anbima 2020</span>
                  </p>
                </div>
                {/*  */}
                <div className="links-menu">
                  <div>
                    <h3>Mensagens</h3>
                    <ul>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/mensagens/presidencia">
                          Carlos Ambrósio
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/mensagens/superintendencia">
                          Zeca Doherty
                        </DelayLink>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h3>Quem somos</h3>
                    <ul>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/quem-somos">
                          Perfil
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/associados">
                          Associados
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/pessoas">
                          Pessoas
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/pessoas/organograma">
                          Organograma 
                        </DelayLink>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h3>Estratégia</h3>
                    <ul>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/plano-de-acao-2020">
                          Resultados do plano de ação 2020
                        </DelayLink>
                      </li>
                      {/* <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/plano-de-acao-2020">
                          Plano de ação 2020
                        </DelayLink>
                      </li> */}
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/relacionamentos">
                          Relacionamentos
                        </DelayLink>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h3>Governança corporativa</h3>
                    <ul>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/governanca-corporativa">
                          Assembleia geral
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/governanca-corporativa/diretoria">
                          Diretoria
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/governanca-corporativa/conselho-fiscal">
                          Conselho Fiscal
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/governanca-corporativa/conselho-de-etica">
                          Conselho de Ética
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/governanca-corporativa/comite-executivo">
                          Comitê Executivo
                        </DelayLink>
                      </li>
                      <li className="line-default" onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/governanca-corporativa/organismos-de-representacao">
                          Organismos de representação e de supervisão
                        </DelayLink>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h3>Nosso ano</h3>
                    <ul>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/estrategias/nosso-ano">
                          Iniciativas
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/eventos">
                          Eventos
                        </DelayLink>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h3>O relatório</h3>
                    <ul>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/sobre-o-relatorio">
                          Sobre o relatório
                        </DelayLink>
                      </li>
                      <li onClick={() => this.menuClicked()}>
                        <DelayLink preventTransition to="/sumario-gri">
                          Sumário GRI
                        </DelayLink>
                      </li>
                    </ul>
                  </div>
                </div>
                {/*  */}
                <div className="imagem-menu">
                  <img src={this.imagemMenu} />
                </div>
                {/* <ul>


                  <ul>
                    <li>
                      <DelayLink preventTransition to="/estrategias/para-o-mercado">
                        Para o mercado
                      </DelayLink>
                    </li>
                    <li>
                      <DelayLink preventTransition to="/estrategias/dentro-de-casa">
                        Dentro de casa
                      </DelayLink>
                    </li>
                  </ul>
                </li>

             */}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export { Menu };
